import _typeof from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
export default {
  data: function data() {
    var _this = this;

    var operatorEmail = function operatorEmail(rule, value, callback) {
      if (value != '') {
        // callback();
        // } else {
        var reg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/;
        var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;

        if (!reg.test(value)) {
          callback(new Error('邮箱格式错误'));
        } else if (!patrn.test(value)) {
          callback(new Error('不能含有特殊符号'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    var operatorName = function operatorName(rule, value, callback) {
      if (value === '') {
        callback();
      } else {
        var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
        var reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;

        if (!reg.test(value)) {
          callback(new Error('姓名格式错误'));
        } else if (patrn.test(value)) {
          callback(new Error('不能含有特殊符号'));
        } else {
          callback();
        }
      }
    };

    var operatorIdnum = function operatorIdnum(rule, value, callback) {
      if (value == '' && (_this.enterpriseCert.certType == null || _this.enterpriseCert.certType == 0)) {
        callback();
      } else {
        var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/;

        if (!reg.test(value)) {
          callback(new Error('身份证号格式有误'));
        } else if (patrn.test(value)) {
          callback(new Error('不能含有特殊符号'));
        } else {
          callback();
        }
      }
    };

    return {
      // showSignFile: false,
      // showAuthoFile: false,
      hrefPre: this.publicMethed.publicUrlPre,
      IdnumFailed: false,
      //身份证号识别失败
      rules: {
        operatorEmail: [{
          required: false
        }, {
          validator: operatorEmail,
          trigger: 'blur'
        }],
        operatorPhone: [{
          required: true,
          message: '经办人联系电话不能为空'
        },, {
          required: true,
          validator: this.publicMethed.regularTest('phoneReg'),
          trigger: 'blur'
        }],
        operatorName: [{
          required: true,
          message: "经办人姓名不能为空",
          trigger: "blur"
        }, {
          validator: operatorName,
          trigger: 'blur'
        }],
        operatorIdnum: [{
          required: true,
          message: "经办人身份证号不能为空",
          trigger: "blur"
        }, {
          validator: operatorIdnum,
          trigger: 'blur'
        }],
        operatorCertnoTime: [{
          required: false,
          trigger: "change"
        }]
      },
      opreaterFileDesc: {
        operatorFace: {
          type: 'o',
          remark: "经办人身份证人像面"
        },
        //操作人人像面图片
        operatorback: {
          type: 'l',
          remark: "经办人身份证国徽面"
        },
        authorizeFile: {
          type: 'm',
          remark: "授权文件"
        },
        //授权文件
        signFile: {
          type: 'n',
          remark: "签章协议"
        } //签章协议

      },
      opreaterFile: {
        operatorFace: '',
        //操作人人像面图片
        operatorback: '',
        authorizeFile: '',
        //授权文件
        signFile: '' //签章协议

      },
      formDec: {
        operatorName: {
          name: '经办人姓名',
          placeholder: '请上传身份证人面像自动识别'
        },
        operatorIdnum: {
          name: '经办人身份证号',
          placeholder: '请上传身份证人面像自动识别'
        },
        operatorCertnoTime: {
          name: '经办人身份证有效期',
          placeholder: '请上传身份证人面像自动识别'
        },
        operatorPhone: {
          name: '联系电话',
          placeholder: '请输入联系电话'
        },
        operatorAddr: {
          name: '联系地址',
          placeholder: '请输入联系地址'
        },
        operatorEmail: {
          name: '邮箱',
          placeholder: '请输入邮箱'
        }
      },
      form: {
        operatorName: '',
        operatorIdnum: '',
        operatorCertnoTime: '',
        operatorPhone: '',
        operatorAddr: '',
        operatorEmail: ''
      },
      errors: {},
      pageFile: {
        authorizeFile: [],
        signFile: []
      },
      //页面内的文件信息
      fileListAutho: [],
      fileListSign: [],
      // 长期
      longTimeOption: {
        operatorCertDisbled: false,
        operatorCertChecked: false
      }
    };
  },
  watch: {
    enterpriseCert: function enterpriseCert(a, b) {
      this.initvalue();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(['enterpriseCert'])), {}, {
    isShowLoad: function isShowLoad() {
      return this.enterpriseCert.certType == 1;
    },
    showSignFile: function showSignFile() {
      return this.pageFile.signFile;
    },
    showAuthoFile: function showAuthoFile() {
      return this.pageFile.authorizeFile;
    }
  }),
  created: function created() {
    this.signFileInfo = {
      oldSignUrl: ''
    };
    this.delFileList = []; //删除的文件列表，保存后，后端同步删除hadoop的文件
  },
  mounted: function mounted() {
    this.initvalue();
  },
  methods: {
    // 切换长期
    longTimeChange: function longTimeChange(value) {
      this.longTimeOption.operatorCertDisbled = value;
      this.form.operatorCertnoTime = value ? "9999-12-31" : this.enterpriseCert.operatorCertnoTime;
    },
    checkAutho: function checkAutho(str) {
      if (this.pageFile[str] && this.pageFile[str].url && this.pageFile[str].url.indexOf('blob:') != -1) {
        if (this.pageFile[str].checkType == "application/pdf") {
          window.open('./pdf/web/viewer.html?file=' + this.pageFile[str].url, "_blank");
        } else if (this.pageFile[str].checkType.indexOf('image') != -1) {
          window.open('./showImage.html?img=' + this.pageFile[str].url);
        }
      } else {
        this.$message.error('正在下载文件，请稍后');
      }
    },
    // 下载授权文件
    downAuthoFile: function downAuthoFile() {
      if (this.form.operatorIdnum == '') {
        this.$message.error('请先上传身份证信息');
        return;
      }

      var data = {
        enterpriseName: this.enterpriseCert.enterpriseName,
        operatorName: this.form.operatorName,
        operatorIdnum: this.form.operatorIdnum,
        legalName: this.enterpriseCert.legalName,
        certno: this.enterpriseCert.certno
      };
      this.publicMethed.newDownFile('/enterpriseCert/downloadAuthoFile', data, 'post', '授权委托书模板.docx');
      return;
    },
    downSignFile: function downSignFile() {
      var _this2 = this;

      // if (this.signFileInfo.oldSignUrl == this.enterpriseCert.notSignContract && typeof this.signFileInfo.fileShow !=
      // 	'undefined') {
      // 	let temType = this.signFileInfo['fileType'] != '' ? this.signFileInfo['fileType'].split('/')[1] : ''
      // 	let name = '签章授权协议.' + temType
      // 	this.publicMethed.saveFileToLocal(this.signFileInfo.fileShow, name)
      // } else {
      // 	let data = {
      // 		fileUrl: this.enterpriseCert.notSignContract
      // 	}
      // 	this.publicMethed.downLoadImageC(data, (res, type) => {
      // 		this.signFileInfo['fileShow'] = res
      // 		this.signFileInfo['fileType'] = type
      // 		this.signFileInfo.oldSignUrl = this.enterpriseCert.notSignContract
      // 		let temType = type != '' ? type.split('/')[1] : ''
      // 		let name = '签章授权协议.' + temType
      // 		this.publicMethed.saveFileToLocal(res, name)
      // 	}, () => {
      // 	})
      // }
      this.requestAPI.downloadContractTemplate().then(function (res) {
        if (res.errorCode === "0000") {
          var result = _this2.publicMethed.base64ToFile(res.data);

          _this2.publicMethed.saveFileToLocal(result.url, "签章授权协议.pdf");
        }
      });
    },
    onChangeFile: function onChangeFile(file, fileList, index, isSingle) {
      var tem = file.name.split('.');
      var _type = tem[tem.length - 1]; // 生产上出现某些电脑上传pdf文件识别不了， 现改为根据后缀名判断文件类型

      var imageList = ['jpg', 'jpeg', 'png', 'bmp', 'pdf'];

      if (imageList.indexOf(_type.toLowerCase()) == -1) {
        this.$message.error("仅支持图片或者pdf格式");
        fileList.pop();
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("请勿上传超过2M的文件!");
        fileList.pop();
        return;
      }

      var _innerList = this.pageFile[index] || []; // 如果只允许上传单份文件时，提示先删除（注意limit不能设置1否则不会执行change事件）


      if (isSingle && this.pageFile[index].length > 0) {
        this.$message.error("文件已上传，请先删除！");
        fileList.pop(); //列表展示是从fileList取而不是我们手动存的，所以也需要删除新添加的

        return;
      }

      var obj = {
        name: file.raw.name,
        fileSize: file.size,
        fileUrl: URL.createObjectURL(file.raw),
        fileName: file.raw.name,
        file: file,
        flowNum: this.enterpriseCert.creditCode,
        fileType: this.opreaterFileDesc[index].type,
        fileNum: _innerList.length,
        checkType: file.raw.type,
        url: URL.createObjectURL(file.raw),
        uid: file.uid,
        // 对于刚点击上传的文件用uid作为文件唯一键，对于已上传的文件，用url作为唯一键
        remark: this.opreaterFileDesc[index].remark
      };

      _innerList.push(obj);

      this.$set(this.pageFile, index, _innerList);
    },
    handleRemove: function handleRemove(file, fileList, index) {
      //当删除的数据中地址是hadoop地址时，需push到delFileList，传至后端删除文件.（目前只有暂存时才会删除）
      if (file.fileUrl && file.fileUrl.indexOf('blob:') == -1) {
        this.delFileList.push(file.fileUrl);
      }

      var _data = this.pageFile[index];
      _data = _data.filter(function (_item) {
        return _item.url != file.url;
      });
      this.$set(this.pageFile, index, _data);
    },
    // 预览文件列表中的文件
    onPreview: function onPreview(file) {
      window.open(file.url);
    },
    changeCertType: function changeCertType() {
      this.$router.push({
        name: 'choseCertRoute',
        params: {
          certType: this.enterpriseCert.certType == 1 ? 0 : 1
        }
      });
    },
    onChangeFace: function onChangeFace(file) {
      var _this3 = this;

      var tem = file.raw.type.split('/');

      if (tem[0] != 'image') {
        this.$message.error("该位置仅支持图片格式");
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("请勿上传超过2M的文件!");
        return;
      } // if(this.pageFile['operatorFace'] &&this.pageFile['operatorFace'][0].fileUrl.indexOf('blob',0) != 0 ){


      var operatorFace = this.pageFile['operatorFace'];

      if (operatorFace) {
        if (operatorFace[0].fileUrl && operatorFace[0].fileUrl.indexOf('blob', 0) != 0) {
          this.delFileList.push(this.pageFile['operatorFace'][0].fileUrl);
        }
      }

      this.$set(this.opreaterFile, 'operatorFace', URL.createObjectURL(file.raw));
      this.pageFile['operatorFace'] = [{
        fileSize: file.size,
        fileUrl: URL.createObjectURL(file.raw),
        fileName: file.raw.name,
        file: file,
        flowNum: this.enterpriseCert.creditCode,
        fileType: this.opreaterFileDesc['operatorFace'].type,
        fileNum: 0,
        uid: file.uid,
        // 对于刚点击上传的文件用uid作为文件唯一键，对于已上传的文件，用url作为唯一键
        remark: this.opreaterFileDesc['operatorFace'].remark //'经办人身份证人像面'

      }];
      var reader = new FileReader();
      reader.readAsDataURL(file.raw);

      reader.onload = function (e) {
        var imgFile = e.target.result;
        var arr = imgFile.split(",");
        var data = {
          type: 2,
          ImgFile: arr[1]
        };

        _this3.requestAPI.ocr2(data).then(function (res) {
          if (res.data.code == 1) {
            _this3.$set(_this3.opreaterFile, 'operatorFace', '');

            _this3.$message.error("身份证人像面识别出错");

            return;
          }

          var tem = res.data;
          _this3.form.operatorName = tem.name;
          _this3.form.operatorIdnum = tem.num;
        }).catch(function () {
          _this3.$set(_this3.opreaterFile, 'operatorFace', '');

          _this3.$message.error("身份证人像面识别出错");
        });
      };
    },
    onChangeBack: function onChangeBack(file) {
      var _this4 = this;

      var tem = file.raw.type.split('/');

      if (tem[0] != 'image') {
        this.$message.error("该位置仅支持图片格式");
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("请勿上传超过2M的文件!");
        return;
      } // 如果上一个文件是上传过的，则让后端删除
      // if(this.pageFile['operatorback'] &&this.pageFile['operatorback'][0].fileUrl.indexOf('blob',0) != 0 ){


      var operatorback = this.pageFile['operatorback'];

      if (operatorback) {
        if (operatorback[0].fileUrl && operatorback[0].fileUrl.indexOf('blob', 0) != 0) {
          this.delFileList.push(this.pageFile['operatorback'][0].fileUrl);
        }
      }

      this.$set(this.opreaterFile, 'operatorback', URL.createObjectURL(file.raw));
      this.pageFile['operatorback'] = [{
        fileSize: file.size,
        fileUrl: URL.createObjectURL(file.raw),
        fileName: file.raw.name,
        file: file,
        flowNum: this.enterpriseCert.creditCode,
        fileType: this.opreaterFileDesc['operatorback'].type,
        fileNum: 1,
        uid: file.uid,
        // 对于刚点击上传的文件用uid作为文件唯一键，对于已上传的文件，用url作为唯一键
        remark: this.opreaterFileDesc['operatorback'].remark // '经办人身份证国徽面',

      }];
      var reader = new FileReader();
      reader.readAsDataURL(file.raw);

      reader.onload = function (e) {
        var imgFile = e.target.result;
        var arr = imgFile.split(",");
        var data = {
          type: 3,
          ImgFile: arr[1]
        };

        _this4.requestAPI.ocr2(data).then(function (res) {
          if (res.data.code == 1) {
            _this4.$set(_this4.opreaterFile, 'operatorback', '');

            _this4.$message.error("身份证国徽面识别出错");

            return;
          }

          var str = "";
          var operatorFlag = res.data.end_date === "长期"; // 判断是否长期

          _this4.longTimeOption.operatorCertDisbled = operatorFlag;
          _this4.longTimeOption.operatorCertChecked = operatorFlag;

          if (operatorFlag) {
            str = "9999-12-31";
          } else {
            str = res.data.end_date.slice(0, 4) + "-" + res.data.end_date.slice(4, 6) + "-" + res.data.end_date.slice(6, 8);
          }

          _this4.form.operatorCertnoTime = str;
        }).catch(function () {
          _this4.$set(_this4.opreaterFile, 'operatorback', '');

          _this4.$message.error("身份证国徽面识别出错");
        });
      };
    },
    uploadImage: function uploadImage(resultData) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var flowNum = _this5.enterpriseCert.creditCode;
        var fileType = resultData.fileType + '' + resultData.fileNum + new Date().getTime();
        var fileNum = 0;

        if (_typeof(resultData.file) == 'object' && typeof resultData.fileUrl == 'string' && (resultData.fileUrl.indexOf('blob', 0) == 0 || resultData.fileUrl.indexOf('10.129') == -1 && resultData.fileUrl.indexOf('hadoop') == -1)) {
          _this5.publicMethed.upLoadImageC(resultData.file, flowNum, fileType, fileNum, function (res, type) {
            resultData['fileUrl'] = res;
            resolve(resultData);
          }, function () {
            reject();
          });
        } else {
          // resultData['fileUrl'] = resultData.fileUrl
          resolve(resultData);
        }
      });
    },
    // 提交数据
    submit: function submit(successBack, failBack) {
      var _this6 = this;

      this.$refs["refForm"].validate(function (valid) {
        if (valid) {
          var fileList = [];

          if (_this6.enterpriseCert.certType == 1) {
            for (var key in _this6.opreaterFile) {
              if (typeof _this6.pageFile[key] != 'undefined') {
                fileList = fileList.concat(_this6.pageFile[key]);
              } else {
                _this6.$message.error("请上传" + _this6.opreaterFileDesc[key].remark);

                failBack();
                return;
              }
            }
          }

          var data = _this6.publicMethed.deepCopy(_this6.form);

          data.sqblrCertnoTime = _this6.form.operatorCertnoTime; //办理人有效期取经办人的
          // 有enterpriseId 说明已经认证过，则无需进行暂存

          if (_this6.enterpriseCert.enterpriseId != null) {
            var tem = {
              page: 'contact',
              data: _objectSpread(_objectSpread({}, _this6.form), {}, {
                sqblrCertnoTime: _this6.form.operatorCertnoTime
              }),
              fileList: fileList
            };
            successBack(tem);
          } else {
            if (fileList.length == 0) {
              _this6.requestAPI.saveTempEnterpriseOperator(data).then(function (res) {
                var tem = {
                  page: 'contact',
                  data: _objectSpread(_objectSpread({}, _this6.form), {}, {
                    sqblrCertnoTime: _this6.form.operatorCertnoTime
                  }),
                  fileList: []
                };
                successBack(tem);
              }).catch(function () {
                failBack();
              });
            } else {
              var tasks = [];

              for (var i = 0; i < fileList.length; i++) {
                tasks.push(_this6.uploadImage(fileList[i]));
              } // 执行tasks中的异步操作


              Promise.all(tasks).then(function (list) {
                var enterpriseFiles = [];
                var tem = [];

                for (var _i = 0; _i < list.length; _i++) {
                  var temFile = {
                    fileUrl: list[_i].fileUrl,
                    fileSize: list[_i].fileSize,
                    fileName: list[_i].fileName,
                    remark: list[_i].remark,
                    fileType: list[_i].fileType
                  };
                  enterpriseFiles.push(temFile);
                }

                data['enterpriseFiles'] = enterpriseFiles;

                if (_this6.delFileList.length != 0) {
                  data['delFileList'] = _this6.delFileList;
                }

                _this6.requestAPI.saveTempEnterpriseOperator(data).then(function (res) {
                  var tem = {
                    page: 'contact',
                    data: _this6.form,
                    fileList: enterpriseFiles
                  };
                  tem.data.sqblrCertnoTime = _this6.form.operatorCertnoTime; //办理人有效期取经办人的
                  // if (temFile.fileUrl && temFile.fileUrl.indexOf('blob') != -1) {
                  // 	delete temFile.file
                  // }

                  _this6.delFileList = [];
                  successBack(tem);
                }).catch(function () {
                  failBack();
                });
              }).catch(function () {
                failBack();
              });
            }
          }
        } else {
          failBack();
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 变更认证回填，初始化数据
    initvalue: function initvalue() {
      for (var key in this.form) {
        this.$set(this.form, key, this.enterpriseCert[key] || ''); // 如果长期

        if (this.form.operatorCertnoTime === '9999-12-31') {
          this.longTimeOption.operatorCertDisbled = true;
          this.longTimeOption.operatorCertChecked = true;
        }
      }

      this.initRule();
    },
    initRule: function initRule() {
      var _this7 = this;

      // 本地缓存有certType值，或者企业信息中有certType值
      if (this.enterpriseCert.certType == 1) {
        // 如果选择了经办人路线，则经办人姓名必输
        var list = ['operatorName', 'operatorIdnum', 'operatorCertnoTime', 'operatorPhone'];

        for (var key in this.rules) {
          if (list.indexOf(key) != -1) {
            var _tem = this.rules[key];
            _tem[0].required = true;
            _tem[0].message = this.formDec[key].name + '不能为空!';
            this.$set(this.rules, key, _tem);
          }
        }

        var tem = [];
        var list1 = []; // 根据opreaterFileDesc默认的数据回填list1中的类型

        for (var _key in this.opreaterFileDesc) {
          list1.push(this.opreaterFileDesc[_key].type);
        }

        for (var i = 0; i < this.enterpriseCert.enterpriseFiles.length; i++) {
          if (list1.indexOf(this.enterpriseCert.enterpriseFiles[i].fileType) != -1) {
            tem.push(this.enterpriseCert.enterpriseFiles[i]);
          }
        }

        this.publicMethed.promiseReFile(tem, function (res) {
          for (var _key2 in _this7.opreaterFileDesc) {
            if (_this7.opreaterFileDesc[_key2].type == res.fileUrlType) {
              //设置预览经办人图片
              if (_key2 == 'operatorFace' || _key2 == 'operatorback') {
                _this7.$set(_this7.opreaterFile, _key2, res.fileShow);
              }

              var _data = _this7.pageFile[_key2] || [];

              _data.push({
                name: res.fileName || _this7.opreaterFileDesc[_key2].remark,
                fileSize: res.fileSize,
                fileUrl: res.fileUrl,
                fileName: res.fileName,
                file: res.fileShow,
                flowNum: _this7.enterpriseCert.creditCode,
                fileType: _this7.opreaterFileDesc[_key2].type,
                fileNum: 1,
                remark: _this7.opreaterFileDesc[_key2].remark,
                checkType: res.fileType,
                url: res.fileShow
              });

              _this7.$set(_this7.pageFile, _key2, _data); // if (key == 'signFile') {
              // 	this.fileListSign.push({
              // 		name: '电子签章委托协议',
              // 		url: res.fileShow,
              // 	})
              // } else if (key == 'authorizeFile') {
              // 	this.fileListAutho.push({
              // 		name: '授权委托书',
              // 		url: res.fileShow,
              // 	})
              // }

            }
          }
        });
      } else {
        var _tem2 = this.formDec['operatorName'];
        _tem2.placeholder = '请输入姓名';
        this.$set(this.formDec, 'operatorName', _tem2);
        var tem1 = this.formDec['operatorIdnum'];
        tem1.placeholder = '请输入身份证号';
        this.$set(this.formDec, 'operatorIdnum', tem1);
        this.IdnumFailed = true;
        var tem2 = this.formDec['operatorCertnoTime'];
        tem2.placeholder = '请选择身份证有效期';
        this.$set(this.formDec, 'operatorCertnoTime', tem2);
      }
    }
  }
};